import { Link } from 'react-router-dom';
import { CheckListWrapper } from './PassengersCheckList.styles';

const PassengersCheckList = ({ shadow }) => {
  return (
    <CheckListWrapper shadow={shadow}>
      <p style={{ margin: 0, fontSize: '13px', color: '#555' }}>
        En effectuant cette réservation, vous acceptez nos{' '}
        <Link
          to="/terms-and-condition"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1A3A6B', textDecoration: 'underline' }}
        >
          conditions générales de vente
        </Link>
        .
      </p>
    </CheckListWrapper>
  );
};

export default PassengersCheckList;
